"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokens = require("@smartsheet/design-tokens");
var React = _interopRequireWildcard(require("react"));
const SvgComponent = _ref => {
  let {
    fillColor = _designTokens.ursaColors.blue400,
    emptyFillColor = _designTokens.ursaColors.neutral00,
    size,
    value,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: `0 0 ${size.width} ${size.height}`
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "3.69995",
    y: "6",
    width: size.width * 0.89,
    height: size.height * 0.4,
    fill: emptyFillColor,
    stroke: fillColor,
    strokeWidth: "1.4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "6",
    width: (size.width - 8) * (value / 100),
    height: size.height * 0.4,
    fill: fillColor,
    stroke: fillColor,
    strokeWidth: "1.4",
    strokeLinejoin: "round"
  }));
};
var _default = SvgComponent;
exports.default = _default;
//# sourceMappingURL=ProgressBarSvg.js.map